import React from 'react';


const ProfileInfoEditCard = ({ cardHeadingIcon,
    cardHeading,
    cardEditIcon,
    cardSaveIcon,
    content,
    EditIcon,
    handleTextAreaChange,
    placeholder,
    profilePageAllContent,
    mobileScreen,
    className
}) => {


    return (
        <>
            <div className={className ? className : "card mt-3 border-0 shadow-sm rounded-4"}>
                <div className="card-body" id={`${cardHeading === "Preference" ? "preferenceCard" : "aboutCard"}`}>
                    <div className="d-flex justify-content-between ms-1">
                        <label className="profile-side-headers d-flex align-items-center placeholder-glow ">
                            {cardHeadingIcon}
                            <span className={profilePageAllContent ? "" : "placeholder px-3 w-100 py-1  rounded-1"}>{`${cardHeading}`}</span>
                        </label>


                        {
                            EditIcon ?
                                <span className={profilePageAllContent ? "" : "placeholder rounded-2"}>{cardSaveIcon}</span>
                                : <span className={profilePageAllContent ? "" : "placeholder rounded-2 "}>{cardEditIcon}</span>

                        }
                    </div>
                    <div className="ms-5 mt-3 profile-descriptions profile-descriptions-profile-page">
                        {/* {cardDescription} */}

                        {
                            cardHeading === "Preference" ?
                                EditIcon ?
                                    <>
                                        <textarea id='preferenceEditField' className={profilePageAllContent ? "w-100 p-3 textarea" : "placeholder px-3 w-100 py-1  rounded-2"} value={content} rows={4} placeholder={profilePageAllContent ? placeholder : ""} onChange={handleTextAreaChange} maxLength="900"></textarea>
                                        <div className='text-start'>
                                            <span className={profilePageAllContent ? 'fw-normal max-char' : "placeholder"}>Max 900 characters</span>
                                        </div>
                                    </>
                                    :
                                    <p id='preferenceNonEditField' className={profilePageAllContent ? 'text-break' : 'text-break placeholder rounded-2 w-100'}>{content ? content : placeholder}</p>
                                :
                                null

                        }


                        {
                            cardHeading === "About" ?
                                EditIcon ?
                                    <>
                                        <textarea id='aboutEditField' className={profilePageAllContent ? "w-100 p-3 textarea " : "placeholder px-3 w-100 py-1  rounded-2"} value={content} rows={4} placeholder={profilePageAllContent ? placeholder : ""} onChange={handleTextAreaChange} maxLength="900" ></textarea>
                                        <div className='text-start'>
                                            <span className={profilePageAllContent ? 'fw-normal max-char' : "placeholder"}>Max 900 characters</span>
                                        </div>
                                    </>
                                    :
                                    <p id='aboutNonEditField' className={profilePageAllContent ? 'text-break' : 'text-break placeholder rounded-2 w-100'}>{content ? content : placeholder}</p>
                                :
                                null
                        }

                    </div>
                </div>
            </div>
        </>
    )
}

export default ProfileInfoEditCard
